/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export const defineConfig = (config) => config;
export const hasOrigin = (origin) => ({
    test: (url) => new URL(url).origin === origin,
});
//# sourceMappingURL=config.js.map